/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Sortdirectionarialabel3Inputs */

const id_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alihkan arah urutan`)
};

const ms_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togol arah susunan`)
};

const da_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift sorteringsretning`)
};

const de_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortierrichtung umschalten`)
};

const en_us2_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle sort direction`)
};

const es_es2_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar dirección de orden`)
};

const es_mx2_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar dirección de orden`)
};

const fil_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-toggle ang direksyon ng pagbukud-bukod`)
};

const fr_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser le sens du tri`)
};

const it_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverti direzione ordinamento`)
};

const hu_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezési irány váltása`)
};

const nl_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteervolgorde omkeren`)
};

const no_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytt sorteringsretning`)
};

const pl_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przełącz kierunek sortowania`)
};

const pt_br2_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar direção de classificação`)
};

const pt_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar direção de ordenação`)
};

const ro_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comută direcția de sortare`)
};

const fi_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda järjestyssuuntaa`)
};

const sv_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Växla sorteringsriktning`)
};

const vi_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển đổi hướng sắp xếp`)
};

const tr_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıralama yönünü değiştir`)
};

const cs_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepnout směr řazení`)
};

const bg_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превключване на посоката на сортиране`)
};

const ru_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить направление сортировки`)
};

const uk_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити напрямок сортування`)
};

const ar_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل اتجاه الترتيب`)
};

const hi_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्रमबद्ध दिशा टॉगल करें`)
};

const th_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนทิศทางการจัดเรียง`)
};

const ja_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並び替え方向を切り替え`)
};

const zh_cn2_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换排序方向`)
};

const zh_hant1_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換排序方向`)
};

const ko_search_sort_sortdirectionarialabel3 = /** @type {(inputs: Search_Sort_Sortdirectionarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬 방향 전환`)
};

/**
* | output |
* | --- |
* | "Toggle sort direction" |
*
* @param {Search_Sort_Sortdirectionarialabel3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_sortdirectionarialabel3 = /** @type {((inputs?: Search_Sort_Sortdirectionarialabel3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Sortdirectionarialabel3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "ms") return ms_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "da") return da_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "de") return de_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "en-US") return en_us2_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "es-ES") return es_es2_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "fil") return fil_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "fr") return fr_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "it") return it_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "hu") return hu_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "nl") return nl_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "no") return no_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "pl") return pl_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "pt") return pt_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "ro") return ro_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "fi") return fi_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "sv") return sv_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "vi") return vi_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "tr") return tr_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "cs") return cs_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "bg") return bg_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "ru") return ru_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "uk") return uk_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "ar") return ar_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "hi") return hi_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "th") return th_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "ja") return ja_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_sortdirectionarialabel3(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_sortdirectionarialabel3(inputs)
	return ko_search_sort_sortdirectionarialabel3(inputs)
});
export { search_sort_sortdirectionarialabel3 as "search.sort.sortDirectionAriaLabel" }